<template>
    <div class="flex items-center">
        <span class="text-cost-red text-2xl font-bold">Save</span>
        <span class="text-cost-blue text-2xl font-bold">At</span>
        <span class="text-cost-red text-2xl font-bold underline">Cost</span>
        <!-- <span class="text-cost-blue text-2xl font-bold">.</span> -->
        <span class="text-cost-red text-2xl font-bold underline">co</span>
    </div>
</template>